import React from "react";
import Accordion from "./Accordion";

const FAQ = () => {

  const faqs = [
    {
      question: '¿Qué es una modelo webcam? ¿De qué se trata el trabajo?',
      answer: 'Es una profesión donde, a través de una cámara, conoces personas de todo el mundo mientras generas ingresos y alcanzas tus metas con nuestra guía y apoyo.'
    },
    {
      question: '¿Cuánto dinero puedo ganar como modelo webcam?',
      answer: 'Tus ingresos no tienen límite y dependen de tu constancia, esfuerzo y dedicación, con nuestro acompañamiento profesional.'
    },
    {
      question: '¿Dónde están ubicados?',
      answer: 'En el sur de Cali, en el barrio Santa Isabel, cerca a la universidad Libre de San Fernando. Atendemos solo con cita previa.'
    },
    {
      question: '¿Cómo es el proceso de pago?',
      answer: 'Los pagos se realizan semanalmente los jueves. Se paga directamente a tu cuenta.'
    },
    {
      question: '¿Debo verme como una modelo para trabajar en VideoChat?',
      answer: 'No, es importante una buena presentación, pero lo esencial es una buena actitud, amabilidad y disposición. Te apoyamos con entrenadoras que te guían en todo momento.'
    },
    {
      question: '¿Qué necesito para comenzar a trabajar?',
      answer: 'Buena presentación, actitud positiva y disposición para aprender. Ser mayor de 18 años y contar con tu cédula de ciudadanía o PPT.'
    },
    {
      question: '¿Necesito tener experiencia para trabajar?',
      answer: 'No, capacitamos y asesoramos desde cero para que logres el éxito en esta profesión.'
    },
    {
      question: '¿Mis conocidos podrán verme?',
      answer: 'Aunque las páginas permiten bloquear tu país de origen, en internet siempre existe un mínimo riesgo de ser descubierta. Es importante informarte de este riesgo de manera responsable.'
    },
    {
      question: '¿Es necesario saber inglés para empezar a trabajar?',
      answer: 'No, pero aprenderlo puede aumentar tus ingresos. Te asesoramos según tu nivel actual.'
    },
    {
      question: '¿Ustedes brindan capacitación y asesoramiento?',
      answer: 'Sí, ofrecemos entrenamiento continuo y acompañamiento personalizado para garantizar tu éxito.'
    }
  ];


  return (
    <>
      <div className="max-w-3xl mx-auto mt-16 mb-16">
        <h2 className="text-5xl font-bold tracking-wide text-center text-secondary mb-6">Preguntas frecuentes</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, index) => (
            <Accordion key={index} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </>
  )

}

export default FAQ;
